import React, { useState } from "react";
import { motion } from "framer-motion";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Contact() {
  const [formData, setFormData] = useState({ nom: "", email: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // ✅ Tes identifiants EmailJS
    const serviceID = "service_d8gk32h";
    const templateID = "template_jhtbtus";
    const publicKey = "_vNHVyvguu30JrLEp";

    // 🕒 Ajoute la date actuelle
  const dateActuelle = new Date().toLocaleString("fr-FR", {
    dateStyle: "full",
    timeStyle: "short",
  });

  const templateParams = {
    from_name: formData.nom,
    from_email: formData.email,
    message: formData.message,
    date: dateActuelle, // 👈 nouvelle variable
  };

    emailjs
      .send(serviceID, templateID, templateParams, publicKey)
      .then(() => {
        toast.success("✅ Votre message a été envoyé avec succès !");
        setFormData({ nom: "", email: "", message: "" });
      })
      .catch((error) => {
        console.error("Erreur :", error);
        toast.error("❌ Une erreur est survenue. Veuillez réessayer.");
      });
  };

  // 🔄 Animation avec Framer Motion
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.35 },
    },
  };

  const fadeItem = {
    hidden: { opacity: 0, y: 50 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeOut" },
    },
  };

  return (
    <motion.section
      id="contact"
      className="py-20 bg-gray-100 px-6 md:px-16"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      variants={container}
    >
      <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar={false} />

      {/* 🏷️ Titre */}
      <motion.div className="text-center mb-12" variants={fadeItem}>
        <h2 className="text-4xl font-bold text-primary mb-4">Contactez-nous</h2>
        <p className="text-gray-600 max-w-2xl mx-auto">
          Vous avez un projet, une question ou besoin d’un devis ?  
          Remplissez le formulaire ci-dessous et notre équipe vous répondra rapidement.
        </p>
      </motion.div>

      {/* 📩 Grille principale */}
      <motion.div
        className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto items-center"
        variants={container}
      >
        {/* 🧾 Formulaire */}
        <motion.form
          onSubmit={handleSubmit}
          className="bg-white p-8 rounded-2xl shadow-md overflow-visible"
          variants={fadeItem}
        >
          <motion.div className="mb-5" variants={fadeItem}>
            <label className="block text-gray-700 font-semibold mb-2">Nom complet</label>
            <input
              type="text"
              name="nom"
              value={formData.nom}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Votre nom"
            />
          </motion.div>

          <motion.div className="mb-5" variants={fadeItem}>
            <label className="block text-gray-700 font-semibold mb-2">Adresse e-mail</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="exemple@email.com"
            />
          </motion.div>

          <motion.div className="mb-5" variants={fadeItem}>
            <label className="block text-gray-700 font-semibold mb-2">Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-primary"
              placeholder="Votre message..."
            ></textarea>
          </motion.div>

          {/* ✅ Bouton corrigé et visible */}
          <motion.button
            type="submit"
            className="bg-blue-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-700 transition w-full mt-4"
            variants={fadeItem}
          >
            Envoyer le message
          </motion.button>
        </motion.form>

        {/* 📍 Coordonnées */}
        <motion.div
          className="text-dark text-center md:text-left"
          variants={fadeItem}
        >
          <h3 className="text-2xl font-semibold mb-4">Virtuo Systems Maroc</h3>
          <p className="mb-2">📍 <strong>Adresse :</strong> Quartier Industriel Sidi Ghanem No 208 Marrakech, Maroc</p>
          <p className="mb-2">📞 <strong>Téléphone :</strong> +212 6 91 98 29 14</p>
          <p className="mb-6">✉️ <strong>Email :</strong> contact@virtuosystems.ma</p>

          <motion.iframe
            title="Carte Virtuo Systems Maroc Marrakech"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.068454527142!2d-8.009002925256578!3d31.63000004225769!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xdafec5119aee3b3%3A0x93deafeb3e606d90!2sMarrakech%2C%20Maroc!5e0!3m2!1sfr!2sma!4v1708451100000!5m2!1sfr!2sma"
            width="100%"
            height="300"
            allowFullScreen=""
            loading="lazy"
            className="rounded-2xl shadow-md"
            variants={fadeItem}
          />
        </motion.div>
      </motion.div>
    </motion.section>
  );
}
